import { default as React, FunctionComponent } from 'react'

import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const StringFormatter: FunctionComponent<Formatter<string>> = ({ value, t }) => (
  <>{value ? value : t(tDefaults('inputs.no-answer'))}</>
)
